import { nextTick } from 'vue';

export function useAnimator() {
  const animator = async (
    element: string,
    animation: string,
    additional = '',
    prefix = 'animate__',
  ) => {
    await nextTick();

    return new Promise((resolve) => {
      const node: HTMLElement | null = document.querySelector(element);
      if (!node) {
        resolve('Animation ended: element not found');
        return;
      }

      const animationName = `${prefix}${animation}`;
      const additionalName = additional ? `${prefix}${additional}` : '';
      node.classList.add(`${prefix}animated`, animationName, additionalName);

      let animationEnded = false;

      function handleAnimationEnd(event: AnimationEvent) {
        event.stopPropagation();
        animationEnded = true;
        node?.classList.remove(
          `${prefix}animated`,
          animationName,
          additionalName,
        );
        resolve('Animation ended');
      }

      node.addEventListener('animationend', handleAnimationEnd, {
        once: true,
      });

      setTimeout(() => {
        if (!animationEnded) {
          node.classList.remove(
            `${prefix}animated`,
            animationName,
            additionalName,
          );
          resolve('Animation ended: timeout');
        }
      }, 500);
    });
  };

  return { animator };
}
